export default {
    id: 'MEDCAL_RX_SEARCH_BUTTON',
    defaultMessage: 'Search'
};
